interface CircleProps {
  variant: "blue" | "red" | "green";
  children?: React.ReactNode;
}

const variants = {
  blue: "bg-blue-500",
  red: "bg-red-500",
  green: "bg-green-500",
}

const Circle = ({ variant, children }: CircleProps) => {
  return (
    <div
      className={`flex items-center justify-center text-white w-10 h-10 rounded-full ${variants[variant]}`}
    >
      {children}
    </div>
  )
}

export default Circle
